var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabletIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 264,
    viewBox: "0 0 264 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1469_7154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264 0H208.364V55.6366H264V0Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1469_7154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.9504 1649.96L70.4652 1641.48L1484.68 227.262L1493.16 235.747L78.9504 1649.96Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-656.441 914.57L-664.926 906.085L749.288 -508.129L757.773 -499.644L-656.441 914.57Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8083 1635.82L56.323 1627.33L1470.54 213.12L1479.02 221.605L64.8083 1635.82Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-670.583 900.428L-679.068 891.942L735.146 -522.271L743.631 -513.786L-670.583 900.428Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6662 1621.68L42.1809 1613.19L1456.39 198.978L1464.88 207.463L50.6662 1621.68Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-684.725 886.286L-693.21 877.8L721.003 -536.413L729.489 -527.928L-684.725 886.286Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.524 1607.53L28.0388 1599.05L1442.25 184.836L1450.74 193.321L36.524 1607.53Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-698.867 872.143L-707.352 863.658L706.861 -550.555L715.347 -542.07L-698.867 872.143Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3819 1593.39L13.8966 1584.91L1428.11 170.694L1436.6 179.179L22.3819 1593.39Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-713.009 858.001L-721.494 849.516L692.719 -564.697L701.204 -556.212L-713.009 858.001Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.23976 1579.25L-0.245519 1570.76L1413.97 156.551L1422.45 165.037L8.23976 1579.25Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-727.151 843.859L-735.637 835.374L678.577 -578.84L687.062 -570.354L-727.151 843.859Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.90237 1565.11L-14.3877 1556.62L1399.83 142.409L1408.31 150.895L-5.90237 1565.11Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-741.293 829.717L-749.779 821.232L664.435 -592.982L672.92 -584.496L-741.293 829.717Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20.0445 1550.97L-28.5298 1542.48L1385.68 128.267L1394.17 136.752L-20.0445 1550.97Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-755.436 815.575L-763.921 807.09L650.293 -607.124L658.778 -598.639L-755.436 815.575Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-34.1866 1536.82L-42.6719 1528.34L1371.54 114.125L1380.03 122.61L-34.1866 1536.82Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-769.578 801.433L-778.063 792.948L636.151 -621.266L644.636 -612.781L-769.578 801.433Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-48.3288 1522.68L-56.8141 1514.2L1357.4 99.9829L1365.88 108.468L-48.3288 1522.68Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-783.72 787.291L-792.205 778.805L622.008 -635.408L630.494 -626.923L-783.72 787.291Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-62.4709 1508.54L-70.9562 1500.05L1343.26 85.8408L1351.74 94.326L-62.4709 1508.54Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-797.862 773.149L-806.347 764.663L607.866 -649.55L616.352 -641.065L-797.862 773.149Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-76.613 1494.4L-85.0983 1485.91L1329.12 71.6986L1337.6 80.1839L-76.613 1494.4Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-812.004 759.006L-820.489 750.521L593.724 -663.692L602.209 -655.207L-812.004 759.006Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-90.7552 1480.26L-99.2405 1471.77L1314.97 57.5565L1323.46 66.0418L-90.7552 1480.26Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-826.146 744.864L-834.632 736.379L579.582 -677.835L588.067 -669.349L-826.146 744.864Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104.897 1466.11L-113.383 1457.63L1300.83 43.4144L1309.32 51.8996L-104.897 1466.11Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-840.288 730.722L-848.774 722.237L565.44 -691.977L573.925 -683.491L-840.288 730.722Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-119.039 1451.97L-127.525 1443.49L1286.69 29.2722L1295.17 37.7575L-119.039 1451.97Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-854.43 716.58L-862.916 708.095L551.298 -706.119L559.783 -697.634L-854.43 716.58Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-133.182 1437.83L-141.667 1429.34L1272.55 15.1301L1281.03 23.6154L-133.182 1437.83Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-868.573 702.438L-877.058 693.953L537.156 -720.261L545.641 -711.776L-868.573 702.438Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.324 1423.69L-155.809 1415.2L1258.4 0.987952L1266.89 9.47323L-147.324 1423.69Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-882.715 688.296L-891.2 679.81L523.013 -734.403L531.499 -725.918L-882.715 688.296Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-161.466 1409.54L-169.951 1401.06L1244.26 -13.1542L1252.75 -4.6689L-161.466 1409.54Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-896.857 674.154L-905.342 665.668L508.871 -748.545L517.357 -740.06L-896.857 674.154Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-175.608 1395.4L-184.093 1386.92L1230.12 -27.2963L1238.61 -18.811L-175.608 1395.4Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-910.999 660.011L-919.484 651.526L494.729 -762.687L503.215 -754.202L-910.999 660.011Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189.75 1381.26L-198.235 1372.78L1215.98 -41.4385L1224.46 -32.9532L-189.75 1381.26Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-925.141 645.869L-933.626 637.384L480.587 -776.829L489.072 -768.344L-925.141 645.869Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-203.892 1367.12L-212.378 1358.63L1201.84 -55.5806L1210.32 -47.0953L-203.892 1367.12Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-939.283 631.727L-947.769 623.242L466.445 -790.972L474.93 -782.486L-939.283 631.727Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-218.034 1352.98L-226.52 1344.49L1187.69 -69.7227L1196.18 -61.2374L-218.034 1352.98Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-953.425 617.585L-961.911 609.1L452.303 -805.114L460.788 -796.628L-953.425 617.585Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-232.177 1338.83L-240.662 1330.35L1173.55 -83.8649L1182.04 -75.3796L-232.177 1338.83Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-967.568 603.443L-976.053 594.958L438.161 -819.256L446.646 -810.771L-967.568 603.443Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-246.319 1324.69L-254.804 1316.21L1159.41 -98.007L1167.89 -89.5217L-246.319 1324.69Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-981.71 589.301L-990.195 580.816L424.019 -833.398L432.504 -824.913L-981.71 589.301Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-260.461 1310.55L-268.946 1302.06L1145.27 -112.149L1153.75 -103.664L-260.461 1310.55Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-995.852 575.159L-1004.34 566.673L409.876 -847.54L418.362 -839.055L-995.852 575.159Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-274.603 1296.41L-283.088 1287.92L1131.13 -126.291L1139.61 -117.806L-274.603 1296.41Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1009.99 561.017L-1018.48 552.531L395.734 -861.682L404.22 -853.197L-1009.99 561.017Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-288.745 1282.27L-297.23 1273.78L1116.98 -140.433L1125.47 -131.948L-288.745 1282.27Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1024.14 546.874L-1032.62 538.389L381.592 -875.824L390.077 -867.339L-1024.14 546.874Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-302.887 1268.12L-311.372 1259.64L1102.84 -154.576L1111.33 -146.09L-302.887 1268.12Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1038.28 532.732L-1046.76 524.247L367.45 -889.967L375.935 -881.481L-1038.28 532.732Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-317.029 1253.98L-325.515 1245.5L1088.7 -168.718L1097.18 -160.232L-317.029 1253.98Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1052.42 518.59L-1060.91 510.105L353.308 -904.109L361.793 -895.623L-1052.42 518.59Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-331.171 1239.84L-339.657 1231.35L1074.56 -182.86L1083.04 -174.375L-331.171 1239.84Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1066.56 504.448L-1075.05 495.963L339.166 -918.251L347.651 -909.766L-1066.56 504.448Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-345.314 1225.7L-353.799 1217.21L1060.41 -197.002L1068.9 -188.517L-345.314 1225.7Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1080.7 490.306L-1089.19 481.821L325.024 -932.393L333.509 -923.908L-1080.7 490.306Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-359.456 1211.55L-367.941 1203.07L1046.27 -211.144L1054.76 -202.659L-359.456 1211.55Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1094.85 476.164L-1103.33 467.678L310.881 -946.535L319.367 -938.05L-1094.85 476.164Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-373.598 1197.41L-382.083 1188.93L1032.13 -225.286L1040.62 -216.801L-373.598 1197.41Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1108.99 462.022L-1117.47 453.536L296.739 -960.677L305.225 -952.192L-1108.99 462.022Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-387.74 1183.27L-396.225 1174.79L1017.99 -239.428L1026.47 -230.943L-387.74 1183.27Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1123.13 447.879L-1131.62 439.394L282.597 -974.819L291.082 -966.334L-1123.13 447.879Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-401.882 1169.13L-410.367 1160.64L1003.85 -253.57L1012.33 -245.085L-401.882 1169.13Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1137.27 433.737L-1145.76 425.252L268.455 -988.962L276.94 -980.476L-1137.27 433.737Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-416.024 1154.99L-424.51 1146.5L989.704 -267.713L998.189 -259.227L-416.024 1154.99Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1151.42 419.595L-1159.9 411.11L254.313 -1003.1L262.798 -994.618L-1151.42 419.595Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-430.166 1140.84L-438.652 1132.36L975.562 -281.855L984.047 -273.369L-430.166 1140.84Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1165.56 405.453L-1174.04 396.968L240.171 -1017.25L248.656 -1008.76L-1165.56 405.453Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-444.309 1126.7L-452.794 1118.22L961.42 -295.997L969.905 -287.512L-444.309 1126.7Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1179.7 391.311L-1188.18 382.826L226.029 -1031.39L234.514 -1022.9L-1179.7 391.311Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-458.451 1112.56L-466.936 1104.07L947.278 -310.139L955.763 -301.654L-458.451 1112.56Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1193.84 377.169L-1202.33 368.683L211.887 -1045.53L220.372 -1037.04L-1193.84 377.169Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-472.593 1098.42L-481.078 1089.93L933.135 -324.281L941.621 -315.796L-472.593 1098.42Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1207.98 363.027L-1216.47 354.541L197.744 -1059.67L206.23 -1051.19L-1207.98 363.027Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-486.735 1084.28L-495.22 1075.79L918.993 -338.423L927.479 -329.938L-486.735 1084.28Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1222.13 348.884L-1230.61 340.399L183.602 -1073.81L192.088 -1065.33L-1222.13 348.884Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-500.877 1070.13L-509.362 1061.65L904.851 -352.565L913.336 -344.08L-500.877 1070.13Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1236.27 334.742L-1244.75 326.257L169.46 -1087.96L177.945 -1079.47L-1236.27 334.742Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-515.019 1055.99L-523.505 1047.51L890.709 -366.708L899.194 -358.222L-515.019 1055.99Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1250.41 320.6L-1258.9 312.115L155.318 -1102.1L163.803 -1093.61L-1250.41 320.6Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-529.161 1041.85L-537.647 1033.36L876.567 -380.85L885.052 -372.364L-529.161 1041.85Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1264.55 306.458L-1273.04 297.973L141.176 -1116.24L149.661 -1107.76L-1264.55 306.458Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-543.304 1027.71L-551.789 1019.22L862.425 -394.992L870.91 -386.507L-543.304 1027.71Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1278.69 292.316L-1287.18 283.831L127.034 -1130.38L135.519 -1121.9L-1278.69 292.316Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-557.446 1013.56L-565.931 1005.08L848.283 -409.134L856.768 -400.649L-557.446 1013.56Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1292.84 278.174L-1301.32 269.689L112.892 -1144.53L121.377 -1136.04L-1292.84 278.174Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-571.588 999.423L-580.073 990.937L834.14 -423.276L842.626 -414.791L-571.588 999.423Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1306.98 264.032L-1315.46 255.546L98.7494 -1158.67L107.235 -1150.18L-1306.98 264.032Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-585.73 985.281L-594.215 976.795L819.998 -437.418L828.484 -428.933L-585.73 985.281Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1321.12 249.89L-1329.61 241.404L84.6073 -1172.81L93.0926 -1164.32L-1321.12 249.89Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-599.872 971.138L-608.357 962.653L805.856 -451.56L814.341 -443.075L-599.872 971.138Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1335.26 235.747L-1343.75 227.262L70.4652 -1186.95L78.9504 -1178.47L-1335.26 235.747Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-614.014 956.996L-622.499 948.511L791.714 -465.703L800.199 -457.217L-614.014 956.996Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1349.41 221.605L-1357.89 213.12L56.323 -1201.09L64.8083 -1192.61L-1349.41 221.605Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-628.156 942.854L-636.642 934.369L777.572 -479.845L786.057 -471.359L-628.156 942.854Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1363.55 207.463L-1372.03 198.978L42.1809 -1215.24L50.6662 -1206.75L-1363.55 207.463Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-642.298 928.712L-650.784 920.227L763.43 -493.987L771.915 -485.502L-642.298 928.712Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1377.69 193.321L-1386.17 184.836L28.0388 -1229.38L36.524 -1220.89L-1377.69 193.321Z",
    fill: "#F4F3F3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.58 211.654L61.9468 58.2807C60.7823 54.6114 63.5226 50.8691 67.3711 50.8691H63.0582C57.75 50.8691 53.9712 56.028 55.5769 61.0907L102.84 210.148C103.875 213.41 106.901 215.626 110.321 215.626H116.001C113.519 215.626 111.326 214.02 110.576 211.654H110.58Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.004 215.625H201.058C206.366 215.625 210.145 210.467 208.539 205.404L206.37 198.56H106.426L110.577 211.651C111.326 214.016 113.523 215.622 116.001 215.622L116.004 215.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.37 198.563L161.277 56.3465C160.242 53.0853 157.216 50.8691 153.795 50.8691H67.3746C63.5261 50.8691 60.7858 54.6114 61.9502 58.2807L106.43 198.56H206.373L206.37 198.563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.463 69.0331L186.534 179.636C188.139 184.695 184.361 189.858 179.052 189.858H122.016C118.595 189.858 115.57 187.641 114.535 184.38L79.4639 73.7773C77.8582 68.7179 81.6369 63.5557 86.9451 63.5557H143.982C147.402 63.5557 150.428 65.7718 151.463 69.0331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.565 69.0331L186.636 179.636C188.242 184.695 184.463 189.858 179.155 189.858H122.118C118.698 189.858 115.672 187.641 114.637 184.38L79.5662 73.7773C77.9605 68.7179 81.7392 63.5557 87.0474 63.5557H144.084C147.504 63.5557 150.53 65.7718 151.565 69.0331Z",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1907 188.849L102.945 210.149C103.98 213.41 107.006 215.626 110.427 215.626H201.164C206.472 215.626 210.251 210.467 208.645 205.404L174.984 99.2471",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.528 198.563H206.472",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.712 205.988H169.852",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4769 50.8691C63.6284 50.8691 60.8881 54.6114 62.0525 58.2807L110.682 211.654C111.432 214.02 113.628 215.626 116.107 215.626",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8665 173.113V232.323C23.8665 237.518 28.0765 241.728 33.2719 241.728H230.727C235.922 241.728 240.132 237.518 240.132 232.323V83.3914C240.132 78.1131 235.853 73.8334 230.574 73.8334L173.926 73.8433C169.759 73.8433 166.073 71.1461 164.812 67.1749L161.379 56.3495C160.344 53.0882 157.318 50.8721 153.897 50.8721H63.1637C57.8555 50.8721 54.0767 56.031 55.6825 61.0937L84.224 151.111C86.1781 157.275 81.5765 163.559 75.1138 163.559H33.4279C28.1495 163.559 23.8698 167.838 23.8698 173.117L23.8665 173.113Z",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8665 138.259V34.8684C23.8665 29.673 28.0765 25.4629 33.2719 25.4629H230.727C235.922 25.4629 240.132 29.673 240.132 34.8684V48.537",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1469_7154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 264,
    height: 264,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1469_7154"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.10352e-05 157.836C58.6328 157.836 106.164 205.367 106.164 264H6.10352e-05V157.836Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletIcon);
export default __webpack_public_path__ + "static/media/tablet-icon.8bc4e9c8.svg";
export { ForwardRef as ReactComponent };